import styled from "styled-components";
import { StyledMainContainer as DefaultMainContainer } from "../styles";

export const StyledMainContainer = styled(DefaultMainContainer)`
  button {
    margin-top: 3px;
  }
`;

export const Dates = styled.div`
  display: flex;
  margin-bottom: 16px;
`;

export const DateContainer = styled.div`
  display: flex;
  flex-direction: column;

  input,
  .react-datepicker {
    border-color: #ebeafb !important;
  }

  :not(:last-child) {
    margin-right: 16px;
  }

  .react-datepicker__input-container {
    input:hover {
      border-color: #4957d2;
    }

    ::before,
    ::after {
      color: #4957d2;
    }
  }

  .react-datepicker__navigation--previous,
  .react-datepicker__navigation--previous:hover {
    border-right-color: #4957d2;
  }

  .react-datepicker__navigation--next,
  .react-datepicker__navigation--next:hover {
    border-left-color: #4957d2;
  }

  .react-datepicker__day:hover {
    background-color: #4957d2;
  }

  .react-datepicker__day--selected {
    background-color: #4957d2;
  }
`;

export const LabelSubText = styled.div`
  color: #797b81;
  display: inline-block;
  margin-left: 3px;
`;

export const CriteriaInfo = styled.div`
  display: flex;
  flex-direction: column;
  pointer-events: ${p => (p.disabled ? "none" : "auto")};
  opacity: : ${p => (p.disabled ? 0.5 : 1)};
`;

export const CriteriaContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  // Each column should support 5 Criteria which are 20px
  // height plus 8 margin bottom resulting in 5 * 28 = 140
  height: 170px;
  overflow-x: auto;
`;

export const Criteria = styled.div`
  display: flex;
  align-items: center;
  color: #2a2a3d;
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 8px;

  > div {
    margin-right: 8px;

    label {
      display: flex;
    }
  }
`;
